import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {LoadingService} from '../../../services/loading.service';

@Component({
    selector: 'myabvv-spinner-overlay',
    standalone: true,
    templateUrl: './spinner-overlay.component.html',
    styleUrls: ['spinner-overlay.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerOverlayComponent {
  protected loadingService = inject(LoadingService);
}
